<template>
  <div :class="['nebPillGroup', { wrap }]"
    :style="computedStyle"
    ref="pillGroup"
  >
    <pill v-for="(p, idx) in computedItems"
      :key="idx"
      :clearable="itemsClearable"
      @clear="() => onPillClear(p, idx)"
    >{{ p }}</pill>
    <div class="nebPillGroup-moreTextWrapper" v-if="hiddenCount > 0">
      <tooltip :content="hiddenItems.join(', ')">
        <span class="nebPillGroup-moreText">{{ `+${hiddenCount} more` }}</span>
      </tooltip>
    </div>

    <neb-button type="textPrimary"
      v-if="itemsClearable && items.length > 0"
      @click="$emit('clear-all')"
    >
      Clear All
    </neb-button>
  </div>
</template>

<script>
import Pill from '../Pill'
import Tooltip from '../Tooltip'
import NebButton from '../../controls/Button'

export default {
  name: 'PillGroup',

  components: {
    Pill,
    Tooltip,
    NebButton
  },

  props: {
    width: {
      type: String,
      default: 'initial'
    },
    height: {
      type: String,
      default: 'initial'
    },
    wrap: {
      type: Boolean,
      default: false
    },
    items: {
      type: Array,
      default: () => []
    },
    itemsClearable: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    cutoffIndex: 100
  }),

  computed: {
    computedStyle () {
      return {
        height: this.height,
        width: this.width
      }
    },
    computedItems () {
      return this.wrap
        ? this.items
        : this.items.slice(0, this.cutoffIndex)
    },
    hiddenCount () {
      return this.items.length - this.computedItems.length
    },
    hiddenItems () {
      return this.items
        .slice(this.cutoffIndex, this.items.length)
    }
  },

  methods: {
    truncatePills () {
      const pills = [...this.$refs.pillGroup.childNodes]
        .filter(n => n.className !== 'nebPillGroup-moreTextWrapper')
      // 74px is the approximate width of the string '+100 more'
      let maxWidth = this.$refs.pillGroup.offsetWidth - 74

      // 60px is the approximate width of the "clear all" button and it's
      // margin.
      if (this.itemsClearable) { maxWidth -= 60 }

      let currentWidth = 0
      let idx = 0

      pills
        .forEach(p => {
          // 10 = margin, 14 = padding, 2 = border
          const newWidth = currentWidth + p.offsetWidth + 10 + 14 + 2
          if (!(newWidth >= maxWidth)) {
            currentWidth = newWidth
            idx += 1
          }
        })

      this.cutoffIndex = idx
    },
    onPillClear (item, index) {
      this.$emit('clear', { item, index })
    }
  },

  watch: {
    items () { this.$nextTick(this.truncatePills) },
    width () { this.$nextTick(this.truncatePills) }
  },

  mounted () { this.$nextTick(this.truncatePills) }
}
</script>

<style lang="scss">
@import  '../../style.scss';

.nebPillGroup {
  box-sizing: border-box;
  overflow: hidden;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  align-content: flex-start;

  &-moreTextWrapper {
    padding: 5px 0;
  }

  &.wrap {
    flex-wrap: wrap;
    align-items: flex-start;
    align-content: flex-start;
  }

  .nebPill {
    margin-bottom: 5px;

    &:not(:last-child) {
      margin-right: 5px;
    }
  }

  &-moreText {
    font-family: $defaultFont;
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: $slate-grey;
  }

  .nebButton {
    margin-top: 6px;
    margin-left: 10px;
  }
}
</style>
